import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mav-nsf-logo',
  templateUrl: './nsf-logo.component.html',
  styleUrls: ['./nsf-logo.component.scss']
})
export class NsfLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
